import { render, staticRenderFns } from "./DiscountInput.vue?vue&type=template&id=2b1addcb&scoped=true"
import script from "./DiscountInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiscountInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DiscountInput.vue?vue&type=style&index=0&id=2b1addcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1addcb",
  null
  
)

export default component.exports